// src/app/services/index.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { filter, isArray } from 'lodash';
import qs from 'qs';
import { staggeredBaseQueryWithBailOut } from 'utils';
import { IDirectoryNode } from './documents';
import { IUser } from './user';

export const publicAPI = createApi({
  reducerPath: 'constantsAPI',
  baseQuery: staggeredBaseQueryWithBailOut(`${process.env.REACT_APP_API_URL}`),
  tagTypes: ['Timezones', 'Languages'],
  endpoints: () => ({}),
});

const api = createApi({
  reducerPath: 'api',
  baseQuery: staggeredBaseQueryWithBailOut(`${process.env.REACT_APP_API_URL}`),
  tagTypes: [
    'Documents',
    'Document',
    'Projects',
    'Project',
    'Users',
    'User',
    'Conversations',
    'Conversation',
    'Messages',
    'Message',
    'Businesses',
    'Business',
    'Folders',
    'Tasks',
    'Task',
    'Notes',
    'Ticket',
    'Tickets',
    'SMS',
    'documentPermissions',
    'Accountant',
    'Accountants',
    'Timezones',
    'Cards',
    'Card',
    'Services',
    'Cart',
    'Order',
    'Notifications',
    'Notification',
    'NotificationsCounter',
    'EngagementLetter',
  ],
  endpoints: () => ({}),
});

export interface IPaginatedRepsonse<T> {
  data: T[];
  pagination: IPaginatedResponseObject;
}

export interface IPaginatedDirectoryRepsonse {
  data: IDirectoryNode[];
  pagination: IPaginatedResponseObject;
  file_object?: IDirectoryNode;
}

export interface ICursorPaginatedResponse<T> {
  result: T[];
  pagination: {
    count: number;
    per_page: number;
    current_position: number;
    next_position: number | null;
    direction: 'next' | 'previous';
  };
}

export interface IEnhancedCursorPaginatedResponse<T> {
  data: T[];
  pagination: {
    has_previous_page: boolean;
    has_next_page: boolean;
    start_cursor: string | null;
    end_cursor: string | null;
  };
}

export interface IViewedFile {
  // last seen feature Interface
  user: IUser;
  viewed_at: string;
}

export interface IPaginatedResponseObject {
  count: number;
  page: number;
  per_page: number;
  pages: number;
}

export interface IFiltersParams<T> {
  filters?: T;
}
export interface IPagintationParams {
  per_page?: number;
  page?: number;
}

export interface ICursorPaginatedParams {
  direction?: 'previous' | 'next';
  start_from?: number | string;
  limit?: number;
}

export interface IFilters {
  [key: string]: TFilterValue;
}
export type TFilterValue = string | number | number[] | string[];

export interface IGetQueryParams<T>
  extends IPagintationParams,
    ICursorPaginatedParams {
  filters: T;
}

export interface IGetCurosrPaginationParams<T> extends ICursorPaginatedParams {}

export const buildQueryParams = (
  params: Partial<IGetQueryParams<any>>,
  flatFilters = false,
) => {
  let { filters, ...other } = params;

  let q1 = qs.stringify(flatFilters ? filters : { filters }, {
    arrayFormat: 'brackets',
    indices: false,
  });
  let q2 = qs.stringify(other, { arrayFormat: 'brackets', indices: false });

  const query = q1 && q2 ? `${q1}&${q2}` : q1 || q2;
  return query ? `?${query}` : '';
};

export default api;
